import React from 'react'
import Modal, { ModalContent } from './modal'
import WistiaPlayer from 'react-player/lib/players/Wistia'

class ViewVideo extends React.Component {
    state = { step: 1 }

    handleNext = () => {
        this.setState({ step: 2 })
    }

    handlePrev = () => {
        this.setState({ step: 1 })
    }

    render() {
        return (
            <Modal callToAction={this.props.children}>
                <ModalContent classNames="video-wrapper">
                    <WistiaPlayer
                        width="100%"
                        height="100%"
                        className="video-player"
                        url={this.props.url}
                    />
                </ModalContent>
            </Modal>
        )
    }
}

export default ViewVideo
